import { forwardRef, memo } from 'react';
// Skillmore UI Components
import type { BreadcrumbItem } from '@empathco/ui-components/src/types';
import AppBar, { type AppBarVariant } from '@empathco/ui-components/src/elements/AppBar';
import AppDrawer from '@empathco/ui-components/src/elements/AppDrawer';
import AppHeader from '@empathco/ui-components/src/elements/AppHeader';
// local imports
import CustomerLogo from '../customers/CustomerLogo';
import usePathConfig from '../config/paths';
import CustomizedAppBar from './CustomizedAppBar';
import CustomizedDrawer from './CustomizedDrawer';

type HeaderProps = {
  readonly admin?: boolean;
  readonly breadcrumbs?: BreadcrumbItem[] | null;
  readonly variant?: AppBarVariant;
  // for Storybook only
  readonly testOpen?: boolean;
};

const Header = forwardRef<HTMLDivElement, HeaderProps>(({
  breadcrumbs,
  variant = 'full',
  testOpen = false,
  ...props
}, ref) => {
  const { DRAWER, ROUTES } = usePathConfig();
  return (
    <AppHeader
        ref={ref}
        logo={<CustomerLogo/>}
        appbar={CustomizedAppBar as typeof AppBar}
        drawer={CustomizedDrawer as typeof AppDrawer}
        items={DRAWER}
        routes={ROUTES}
        breadcrumbs={breadcrumbs || undefined}
        variant={variant}
        testOpen={testOpen}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
    />
  );
});

Header.displayName = 'Header';

export default memo(Header);
